<section class="section-separator no-margin padding-top-20"></section>
<section class="row padding-10">
	<p class="text-16">
		<icon class="color-orange" type="exclamation-triangle"></icon>
		<span class="icon-caption text-bold padding-left-10" dcrHTMLKey="ASSET_CLASS_REPLACE_TITLE">Asset Classes have been replaced with ETFs</span>
	</p>
	<p class="text-14 padding-top-10" dcrHTMLKey="ASSET_CLASS_REPLACE_TEXT">
		Asset Classes in your portfolio/sleeves have been replaced with an equivalent ETF so that the model can be analyzed.
	</p>
</section>
